import styled from 'styled-components';

export const PrimaryButton = styled.button`
    padding: 8px 20px;
    background: linear-gradient(135deg, #1a4d4d, #0f3333);
    color: white;
    border: none;
    border-radius: 6px;
    font-size: 15px;
    font-weight: 300;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: all 0.2s ease;

    &:hover:not(:disabled) {
        opacity: 0.9;
        transform: translateY(-1px);
    }

    &:disabled {
        background: linear-gradient(135deg, #1a4d4d, #0f3333);
        cursor: not-allowed;
        opacity: 0.6;
    }
`;
